// export { default } from "./components/VueToastr.vue";
// export { default as Toastr } from "./components/Toastr.vue";
// export { default as Toast } from "./components/Toast.vue";
// export { default as ToastProgress } from "./components/ToastProgress.vue";
import VueToastr from "./VueToastr.vue"
export default VueToastr
